import { cn } from '@/lib/utils'
import { getVisitorOrbGradient } from '@/lib/utils/visitorAvatar'

/**
 * A visitor's avatar: a blurred colour orb seeded by the visitor key, so the
 * same visitor looks the same in the live feed and on their profile. The
 * generated name sits beside it, so no initials.
 */
export function VisitorOrb({ visitorKey, className }: { visitorKey: string; className?: string }) {
  return (
    <span
      aria-hidden
      style={{ backgroundImage: getVisitorOrbGradient(visitorKey) }}
      className={cn(
        'block shrink-0 rounded-full ring-2 ring-white shadow-[0_1px_3px_rgb(0_0_0/0.18)] dark:ring-white/80',
        className,
      )}
    />
  )
}
